import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FormatAlignCenterIcon(props: IconProps) {
    return <Icon {...props} iconKey={"format_align_center"}/>
}
